import "../scss/index.scss";
import OsmMap from './components/OsmMap.js';
import CarbonReportForm from './components/CarbonReportForm.js';
import SidebarNews from './components/SidebarNews.js';
import FooterMiniCart from './components/FooterMiniCart.js';
import AdherentDirectoryFilterRegion from './components/AdherentDirectoryFilterRegion.js';

jQuery(function ($) {
    
    if ($('.js-trainees-collection').length) {
            var $wrapper = $('.js-trainees-collection');

            $wrapper.on('click', '.js-trainees-collection-add', function(e) {
                e.preventDefault();
                
                var limit = $wrapper.data('item-limit');
                var itemCount = $('.js-trainees-collection-item').length;

                if (itemCount < limit) {

                    // Get the data-prototype explained earlier
                    var prototype = $wrapper.data('prototype');
                    // get the new index
                    var index = $wrapper.data('index');
                    // Replace '__name__' in the prototype's HTML to
                    // instead be a number based on how many items we have
                    var newForm = prototype.replace(/__name__/g, index);
                    // increase the index with one for the next item
                    $wrapper.data('index', index + 1);
                    // Display the form in the page before the "new" link
                    $(this).before(newForm);
                }
            });
            
            $wrapper.on('click', '.js-trainees-collection-remove', function(e) {
                e.preventDefault();
                $(this).closest('.js-trainees-collection-item')
                    .fadeOut()
                    .remove();
            });
    }

    $('.chatbot').on('click', function(e) {
        e.preventDefault();
        $('.chaport-launcher-button').click();
    });
    
    $('#btn-article-back').on('click',function() {
        if ('referrer' in document) {
            window.location = document.referrer;
            /* OR */
            //location.replace(document.referrer);
        } else {
            window.history.back();
        }
    });
    
    
    $('.seila-extranet__search-form__icon').on('click',function(event) {
        $('.seila-extranet__search-form').submit();
    });
    
    $('.btn-add-to-cart').on('click',function(event) {
        event.preventDefault();
        $('.single_add_to_cart_button').click();
    });
    
    $('.otgs-development-site-front-end').hide();
    
    if ($('#seila-adherent-map').length) {
       var elt = $('#seila-adherent-map');
       var seilaAdherentMap =  new OsmMap(elt.attr('id'), elt.data('markers'), elt.data('zoom'));
    }
    
    var seilaCarbonReportForm =  new CarbonReportForm('carbon-report-form');
    var footerMiniCart = new FooterMiniCart();
    var seilaExtranetSidebarNews = new SidebarNews();
    var adherentDirectoryFilterRegion = new AdherentDirectoryFilterRegion();
    
    //permutation du bouton  menu (partie internet)

    if ($('.btn-menu--open').length) {
        $('.btn-menu--open').on('click', function(event) {
            elementorProFrontend.modules.popup.showPopup( { id: 1879 },event );
        });
    }
    
    if ($('.btn-menu--close').length) {
        $('.btn-menu--close').on('click', function(event) {
            elementorProFrontend.modules.popup.closePopup( { id: 1879 },event );
        });
    }
    
    $( document ).on( 'elementor/popup/show', ( event, id, instance ) => {
            if ( id === 1879 ) {
                jQuery('.btn-menu--open').hide();
                jQuery('.btn-menu--close').show();
                if (jQuery('.modal-menu .btn-menu--close').length) {
                    jQuery('.modal-menu .btn-menu--close').on('click', function(event) {
                        elementorProFrontend.modules.popup.closePopup( { id: 1879 },event );
                    });
                }
            }
    } );
    $( document ).on( 'elementor/popup/hide', ( event, id, instance ) => {
            if ( id === 1879 ) {
                jQuery('.btn-menu--open').show();
                jQuery('.btn-menu--close').hide();
            }
    } );
    
    function addEvent(event, selector, callback, context) {
        document.addEventListener(event, e => {
            if ( e.target.closest(selector) ) {
                callback(e);
            }
        });
    }
    
    addEvent('click', '.cmplz-show-banner', function(){
        document.querySelectorAll('.cmplz-manage-consent').forEach(obj => {
            obj.click();
        });
    });
    
}); // jQuery End
